"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Desio certificazione contatti
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LottoCertificazioniDtoToJSON = exports.LottoCertificazioniDtoFromJSONTyped = exports.LottoCertificazioniDtoFromJSON = void 0;
const runtime_1 = require("../runtime");
function LottoCertificazioniDtoFromJSON(json) {
    return LottoCertificazioniDtoFromJSONTyped(json, false);
}
exports.LottoCertificazioniDtoFromJSON = LottoCertificazioniDtoFromJSON;
function LottoCertificazioniDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !runtime_1.exists(json, 'id') ? undefined : json['id'],
        'idLotto': !runtime_1.exists(json, 'idLotto') ? undefined : json['idLotto'],
        'idCertificazione': !runtime_1.exists(json, 'idCertificazione') ? undefined : json['idCertificazione'],
        'idWorkflowCertificazione': !runtime_1.exists(json, 'idWorkflowCertificazione') ? undefined : json['idWorkflowCertificazione'],
        'workflowCertificazioneNome': !runtime_1.exists(json, 'workflowCertificazioneNome') ? undefined : json['workflowCertificazioneNome'],
        'ndg': !runtime_1.exists(json, 'ndg') ? undefined : json['ndg'],
        'filialeNdg': !runtime_1.exists(json, 'filialeNdg') ? undefined : json['filialeNdg'],
        'nominativoNdg': !runtime_1.exists(json, 'nominativoNdg') ? undefined : json['nominativoNdg'],
        'emailAnagrafe': !runtime_1.exists(json, 'emailAnagrafe') ? undefined : json['emailAnagrafe'],
        'emailFirmaBiometricaAnagrafe': !runtime_1.exists(json, 'emailFirmaBiometricaAnagrafe') ? undefined : json['emailFirmaBiometricaAnagrafe'],
        'emailHomeBanking': !runtime_1.exists(json, 'emailHomeBanking') ? undefined : json['emailHomeBanking'],
        'cellulareAnagrafe': !runtime_1.exists(json, 'cellulareAnagrafe') ? undefined : json['cellulareAnagrafe'],
        'cellulareHomeBanking': !runtime_1.exists(json, 'cellulareHomeBanking') ? undefined : json['cellulareHomeBanking'],
        'motivazioneScarto': !runtime_1.exists(json, 'motivazioneScarto') ? undefined : json['motivazioneScarto'],
        'dataInserimento': !runtime_1.exists(json, 'dataInserimento') ? undefined : (new Date(json['dataInserimento'])),
        'dataCertificazione': !runtime_1.exists(json, 'dataCertificazione') ? undefined : (json['dataCertificazione'] === null ? null : new Date(json['dataCertificazione'])),
        'statoCertificazione': !runtime_1.exists(json, 'statoCertificazione') ? undefined : json['statoCertificazione'],
    };
}
exports.LottoCertificazioniDtoFromJSONTyped = LottoCertificazioniDtoFromJSONTyped;
function LottoCertificazioniDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'idLotto': value.idLotto,
        'idCertificazione': value.idCertificazione,
        'idWorkflowCertificazione': value.idWorkflowCertificazione,
        'workflowCertificazioneNome': value.workflowCertificazioneNome,
        'ndg': value.ndg,
        'filialeNdg': value.filialeNdg,
        'nominativoNdg': value.nominativoNdg,
        'emailAnagrafe': value.emailAnagrafe,
        'emailFirmaBiometricaAnagrafe': value.emailFirmaBiometricaAnagrafe,
        'emailHomeBanking': value.emailHomeBanking,
        'cellulareAnagrafe': value.cellulareAnagrafe,
        'cellulareHomeBanking': value.cellulareHomeBanking,
        'motivazioneScarto': value.motivazioneScarto,
        'dataInserimento': value.dataInserimento === undefined ? undefined : (value.dataInserimento.toISOString()),
        'dataCertificazione': value.dataCertificazione === undefined ? undefined : (value.dataCertificazione === null ? null : value.dataCertificazione.toISOString()),
        'statoCertificazione': value.statoCertificazione,
    };
}
exports.LottoCertificazioniDtoToJSON = LottoCertificazioniDtoToJSON;
